import { Link } from 'react-router-dom';

export default function Footer() {
  const contractorCategories1 = [
    { name: 'Roofing Contractors', path: '/roofing-contractors-el-paso' },
    { name: 'HVAC Contractors', path: '/hvac-contractors-el-paso' },
    { name: 'Plumbing Contractors', path: '/plumbing-contractors-el-paso' },
    { name: 'Electrical Contractors', path: '/electrical-contractors-el-paso' },
    { name: 'Residential Remodeling', path: '/residential-remodeling-contractors-el-paso' },
    { name: 'Painting Contractors', path: '/painting-contractors-el-paso' },
    { name: 'Flooring Contractors', path: '/flooring-contractors-el-paso' },
    { name: 'Window & Door Contractors', path: '/window-door-replacement-el-paso' },
    { name: 'Solar Panel Installers', path: '/solar-contractors-el-paso' },
    { name: 'Pool Contractors', path: '/swimming-pool-contractors-el-paso' },
    { name: 'Fence Contractors', path: '/fence-contractors-el-paso' },
    { name: 'Handyman Services', path: '/handyman-services-el-paso' },
  ];

  const contractorCategories2 = [
    { name: 'Custom Home Builders', path: '/custom-home-builders-el-paso' },
    { name: 'Commercial Contractors', path: '/commercial-contractors-el-paso' },
    { name: 'Masonry Contractors', path: '/masonry-contractors-el-paso' },
    { name: 'Countertop Installers', path: '/granite-quartz-countertops-el-paso' },
    { name: 'Tile Installers', path: '/tile-installers-el-paso' },
    { name: 'Drywall Contractors', path: '/drywall-contractors-el-paso' },
    { name: 'Garage Door Services', path: '/garage-door-contractors-el-paso' },
    { name: 'Fireproofing Contractors', path: '/fireproofing-companies-el-paso' },
  ];

  return (
    <footer className="bg-gradient-to-br from-teal-600 to-teal-700 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Column 1: Ad Graphic */}
          <div className="bg-white rounded-xl p-8 text-center">
            <div className="mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/e045f2b6072039934624fea1ab287248.jpg" 
                alt="Granite and Quartz Countertops"
                className="w-full h-48 object-cover object-top rounded-lg mb-4"
              />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">
              Premium Countertops
            </h3>
            <p className="text-gray-700 text-sm mb-4">
              Best prices on Granite and Quartz for your countertops
            </p>
            <Link 
              to="/countertops-contractors-el-paso" 
              className="inline-block px-6 py-2 bg-teal-600 text-white font-medium rounded-lg hover:bg-teal-700 transition-colors text-sm whitespace-nowrap"
            >
              Get Free Quote
            </Link>
          </div>

          {/* Column 2: First Half of Contractor List */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contractor Services</h4>
            <ul className="space-y-2 text-sm">
              {contractorCategories1.map((category, index) => (
                <li key={index}>
                  <Link 
                    to={category.path}
                    className="text-white/90 hover:text-white hover:underline transition-colors cursor-pointer"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Second Half of Contractor List */}
          <div>
            <h4 className="text-lg font-bold mb-4 opacity-0">Services</h4>
            <ul className="space-y-2 text-sm">
              {contractorCategories2.map((category, index) => (
                <li key={index}>
                  <Link 
                    to={category.path}
                    className="text-white/90 hover:text-white hover:underline transition-colors cursor-pointer"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/20">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex items-center gap-6 text-sm text-white/80">
              <Link to="/sitemap" className="hover:text-white transition-colors cursor-pointer">Sitemap</Link>
              <a href="#privacy" className="hover:text-white transition-colors cursor-pointer">Privacy Policy</a>
              <a href="#terms" className="hover:text-white transition-colors cursor-pointer">Terms of Service</a>
              <a href="#contact" className="hover:text-white transition-colors cursor-pointer">Contact Us</a>
            </div>
            <div className="text-sm text-white/80">
              © 2024 El Paso Contractors. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
